function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
//import DatacatalogTableService from '@/services/datacatalog_table_service'
import tables_service from '@/apps/data-platform/services/tables_views/tables_service.js';
import assignments_service from '@/apps/data-platform/services/tables_views/assignments_service';
import appApis from '@/services/services';
import ModalConfirm from '@/components/ModalConfirm';
import DialogConfirmationComponent from '@/components/DialogConfirmationComponent.vue';
import PaginationCatalog from '@/components/PaginationCatalog.vue';
import { textsDefaul, envConfig, TYPE_CHANGE_METADA, TAG_QUERIES, DEFAULT_TPL_FIELDS, GA_EVENTS } from '@/js/constants';
import tasks from '@/js/tasks';
import utils from '@/js/utils';
import XLSX from 'xlsx';
import SearchInTableNew from '@/components/refactoring/SearchInTable.vue';
export default {
  name: 'DownloadMetadataPage',
  components: {
    ModalConfirm: ModalConfirm,
    DialogConfirmationComponent: DialogConfirmationComponent,
    PaginationCatalog: PaginationCatalog,
    SearchInTableNew: SearchInTableNew
  },
  data: function data() {
    return {
      MODAL_CONFIRM_FULL: 'MODAL_CONFIRM_FULL',
      dialogFlag: false,
      collapse_filter: false,
      queryResponse: null,
      TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
      PAGE_SIZE: envConfig.pagintaionSize,
      PAGE_TAGS_SIZE: envConfig.pagintaionTagsSize,
      Q_DEFAULT: TAG_QUERIES.ALL_WITH_OWNER,
      messageEmptyList: textsDefaul.LOADING,
      filter: '',
      selected: [],
      tablesToDownload: Array,
      isButtonDownloadHidden: false,
      checkAll: false,
      paramsSearch: {},
      isNewQuery: true,
      showAll: true,
      isLoading: false,
      isLoadingCsv: false,
      isHovered: false,
      isLoadingTables: false,
      domainTables: window.userInfo.domain,
      filter_enabled: false,
      // true,
      pagination: {
        current: 1,
        limit: 10,
        total: 0,
        offset: 0
      },
      nextToken: {},
      key_pagination: 1,
      key_table: 1,
      full_metadata: false,
      source: "bigquery",
      detail_tables_load: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('data-platform', ['isDomainItc', 'projects', 'catalogs', 'isSynapseActive'])), mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    headers: function headers() {
      return [
      //{ value: 'selected', variant: 'return-sort' },
      {
        text: this.traductor('my_tasks.tablas_tasks.table'),
        value: 'tableReference.tableId',
        sortable: true,
        class: 'text-left'
      }, {
        text: this.traductor('my_tasks.tablas_tasks.operator'),
        value: "defaultFields.".concat(DEFAULT_TPL_FIELDS.OPERATOR.name, ".stringValue"),
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_tasks.tablas_tasks.columns'),
        value: 'schema.fields.length',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_tasks.tablas_tasks.rows'),
        value: 'numRows',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_tasks.tablas_tasks.creation_date'),
        value: 'creationTime',
        sortable: true,
        align: 'center'
      }];
    },
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.traductor('my_tasks.subtitle_download_metadata'),
        disabled: true
      }];
    },
    isEmptyTable: function isEmptyTable() {
      return !(this.queryResponse && this.queryResponse.tables);
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) return 'col-md-9 col-sm-12';else return 'col-sm-12';
    }
  }),
  created: function created() {
    this.reloadList();
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    enterSelect: function enterSelect() {
      this.tablesToDownload = this.selected;
      console.log("dbug:", this.tablesToDownload);
      this.isButtonDownloadHidden = this.tablesToDownload.length > 0;
    },
    showAllTables: function showAllTables() {
      var showAll = this.showAll;
      this.PAGE_SIZE = showAll ? 1000 : envConfig.pagintaionSize;
      this.reloadList();
      this.showAll = !showAll;
    },
    sendToSearch: function sendToSearch(q, domain, allDomains) {
      var conditions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
      var source = arguments.length > 4 ? arguments[4] : undefined;
      this.source = source;
      this.domainTables = domain === null ? 'All' : domain;
      this.Q_DEFAULT = "".concat(TAG_QUERIES.ALL_WITH_OWNER, " ").concat(q); // add input to filter
      var params = {
        query: this.Q_DEFAULT,
        domain: domain,
        allDomains: allDomains,
        conditions: conditions,
        source: source
      };
      this.isNewQuery = true;
      this.pagination.current = 1;
      this.pagination.tokens = {};
      this.pagination.next_page_token = {};
      this.key_pagination += 1;
      this.reloadList(params); // reload list
    },
    processParams: function processParams(params) {
      var _ref = params || {},
        _ref$email = _ref.email,
        email = _ref$email === void 0 ? window.userInfo.email : _ref$email,
        _ref$domain = _ref.domain,
        domain = _ref$domain === void 0 ? window.userInfo.domain : _ref$domain,
        _ref$query = _ref.query,
        query = _ref$query === void 0 ? this.Q_DEFAULT || '' : _ref$query,
        _ref$pageSize = _ref.pageSize,
        pageSize = _ref$pageSize === void 0 ? this.PAGE_SIZE : _ref$pageSize,
        _ref$searchWithTags = _ref.searchWithTags,
        searchWithTags = _ref$searchWithTags === void 0 ? true : _ref$searchWithTags,
        _ref$allDomains = _ref.allDomains,
        allDomains = _ref$allDomains === void 0 ? false : _ref$allDomains,
        _ref$approval_flow = _ref.approval_flow,
        approval_flow = _ref$approval_flow === void 0 ? false : _ref$approval_flow,
        _ref$nextToken = _ref.nextToken,
        nextToken = _ref$nextToken === void 0 ? undefined : _ref$nextToken,
        _ref$conditions = _ref.conditions,
        conditions = _ref$conditions === void 0 ? undefined : _ref$conditions,
        _ref$noProcessQuery = _ref.noProcessQuery,
        noProcessQuery = _ref$noProcessQuery === void 0 ? true : _ref$noProcessQuery;
      this.paramsSearch = nextToken === undefined ? {
        email: email,
        domain: domain,
        query: query,
        pageSize: pageSize,
        searchWithTags: searchWithTags,
        allDomains: allDomains,
        approval_flow: approval_flow,
        nextToken: nextToken,
        conditions: conditions,
        noProcessQuery: noProcessQuery
      } : _objectSpread(_objectSpread({}, this.paramsSearch), {}, {
        nextToken: nextToken
      });
      return this.paramsSearch;
    },
    reloadList: function reloadList(params) {
      var _this = this;
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      if (this.$refs.selectableTable) {
        this.checkAll = false;
        this.$refs.selectableTable.clearSelected();
      }
      var defaultParams = this.processParams(params);
      defaultParams["nextToken"] = this.nextToken;
      defaultParams['projects'] = this.projects;
      defaultParams['catalogs'] = this.catalogs;
      defaultParams['source'] = this.source;
      var self = this;
      // clear section table
      this.isLoading = true;
      //appApis
      //  .queryServiceNew(defaultParams)
      tables_service.massive_metadata_download(defaultParams).then(function (response) {
        console.log("requests:", response.data);
        _this.isLoading = false;
        if (response && response.code === 200) {
          if (response && response.data && response.data.tables && response.data.tables.length) {
            if (response.data.next_page_token && Object.keys(response.data.next_page_token).length > 0) {
              console.log("has next page");
              if (!_this.pagination.tokens) _this.pagination.tokens = {};
              _this.pagination.tokens[_this.pagination.current + 1] = response.data.next_page_token;
              _this.pagination.next_page_token = response.data.next_page_token;
            } else {
              console.log("no next page");
              _this.pagination.next_page_token = {};
            }
            _this.key_pagination += 1;
            _this.queryResponse = response.data || {};
            self.getTagsTables(self.queryResponse.tables);
            self.getDetailsTables(self.queryResponse.tables);
            //tasks.combineTagsInRows(this.queryResponse)
          } else {
            _this.queryResponse = response.data || {};
            _this.messageEmptyList = textsDefaul.NOT_TABLES;
          }
        } else if (response && response.code === 400) {
          // alert(response.message)
        } else {
          //this.reloadList(defaultParams, callback)
        }
        callback && callback(response);
      }).catch(function (e) {
        utils.printError(e);
        //this.reloadList(defaultParams, callback)
      });
    },
    getTagsTables: function getTagsTables(tables) {
      var _this2 = this;
      this.detail_tables_load = false;
      var params = {
        tables: tables,
        source: this.source
      };
      tables_service.getTags(params).then(function (response) {
        _this2.detail_tables_load = true;
        _this2.loading_tags = false;
        if (response.data) {
          _this2.queryResponse.tables.forEach(function (item) {
            response.data.forEach(function (x) {
              if (item.relativeResourceName == x.relativeResourceName) {
                item['tags'] = x['tags'];
                x['tags'].forEach(function (tag) {
                  if (tag.templateDisplayName == 'tpl_tables') {
                    item['defaultFields'] = tag;
                  }
                });
              }
            });
          });
          console.log(_this2.queryResponse.tables);
          tasks.combineTagsInRows(_this2.queryResponse);
          if (_this2.loading_tags == false && _this2.loading_schema == false) {
            //this.verifyColumnsWithoutTags()
          }
          _this2.key_table += 1;
        }
      }, function (err) {
        _this2.loading_tags = false;
      });
    },
    getDetailsTables: function getDetailsTables(_tables) {
      var _this3 = this;
      var tables = [];
      this.queryResponse.tables.forEach(function (item) {
        tables.push({
          projectId: item.tableReference.projectId,
          datasetId: item.tableReference.datasetId,
          tableId: item.tableReference.tableId,
          domain_table: item.domain_table,
          source: item.source ? item.source : "bigquery"
        });
      });
      var params = {
        'tables': tables
      };
      assignments_service.getTablesDetails(params).then(function (response2) {
        _this3.loading_schema = false;
        console.log(response2);
        if (response2.data) {
          var _loop = function _loop(key) {
            var items = _this3.queryResponse.tables.filter(function (x) {
              return x.id == response2.data[key].id;
            });
            items.forEach(function (y) {
              y['schema'] = response2.data[key]['schema'];
              y['numRows'] = response2.data[key]['numRows'];
              y['creationTime'] = response2.data[key]['creationTime'];
            });
          };
          for (var key in response2.data) {
            _loop(key);
          }
          if (_this3.loading_tags == false && _this3.loading_schema == false) {
            //this.verifyColumnsWithoutTags()
          }
          _this3.key_table += 1;
        }
      }, function (err) {
        _this3.loading_schema = false;
      });
    },
    onRowSelected: function onRowSelected(items) {
      this.tablesToDownload = items;
      this.isButtonDownloadHidden = this.tablesToDownload.length > 0;
    },
    onConfirm: function onConfirm(event) {
      if (event) {
        this.downloadFullCSV();
      } else this.downloadLiteCSV();
    },
    downloadFullCSV: function downloadFullCSV() {
      this.isLoadingCsv = true;
      this.$refs["dialogConfirmation"].onClose();
      //this.$bvModal.hide(this.MODAL_CONFIRM_FULL)
      var data = '';
      var result = null;
      var today = new Date().toISOString().substring(0, 10);
      var fileName = "data-platform-massive-metadata-full-".concat(today, ".csv");
      var massive = false;
      var _iterator = _createForOfIteratorHelper(this.tablesToDownload),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var table = _step.value;
          var params = {
            table: table,
            default_fields: table.defaultFields,
            tags: table.tags,
            tableReference: table.tableReference,
            massive: massive
          };
          result = tasks.buildDataCSV(params);
          data += "".concat(result.data, "\n");
          massive = true;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.isLoadingCsv = false;
      if (this.$gtm.enabled() && window.dataLayer) {
        window.dataLayer.push({
          event: GA_EVENTS.DOWNLOAD_MASSIVE_METADATA,
          company_code: this.companyCode,
          all_tables: false,
          full: true,
          hash_email: this.stringToHash(userInfo.email),
          module: 'data_platform'
        });
      }
      tasks.saveData(data, fileName);
    },
    downloadLiteCSV: function downloadLiteCSV() {
      var _this4 = this;
      this.isLoadingCsv = true;
      this.$refs["dialogConfirmation"].onClose();
      //this.$bvModal.hide(this.MODAL_CONFIRM_FULL)
      var dataToExport = this.tablesToDownload.map(function (table) {
        return _this4.mapTables(table);
      });
      var data = XLSX.utils.json_to_sheet(dataToExport);
      var csvData = XLSX.utils.sheet_to_csv(data, {
        FS: ';'
      });
      var today = new Date().toISOString().substring(0, 10);
      var fileName = "data-platform-massive-metadata-lite-".concat(today, ".csv");
      this.isLoadingCsv = false;
      if (this.$gtm.enabled() && window.dataLayer) {
        window.dataLayer.push({
          event: GA_EVENTS.DOWNLOAD_MASSIVE_METADATA,
          company_code: this.companyCode,
          all_tables: false,
          full: false,
          hash_email: this.stringToHash(userInfo.email),
          module: 'data_platform'
        });
      }
      tasks.saveData(csvData, fileName);
    },
    mapTables: function mapTables(table) {
      return {
        domain: table.domain || table.domain_table,
        project: table.project || table.tableReference.projectId,
        dataset: table.dataset || table.tableReference.datasetId,
        table: table.table || table.tableReference.tableId,
        operator: table.operator || table.defaultFields.operator.stringValue
      };
    },
    handleHover: function handleHover(hovered) {
      this.isHovered = hovered;
    },
    downloadExcelProdTables: function downloadExcelProdTables(event) {
      var _this5 = this;
      this.full_metadata = false;
      if (event) {
        this.full_metadata = true;
      }
      this.isLoadingTables = true;
      var params = {
        allDomains: this.domainTables === 'All',
        domain: this.domainTables,
        full_metadata: this.full_metadata,
        source: this.source
      };
      //DatacatalogTableService.getProdTables(params)
      tables_service.tables_prod_get_all(params).then(function (response) {
        console.log("prod: ", response.data);
        if (response.data[0] == 'has_request') {
          tasks.toast.error('Ya tienes una solicitud en proceso');
          _this5.isLoadingTables = false;
          return;
        }
        if (response.data.length > 0) {
          var dataToExport = response.data.map(function (table) {
            return _this5.mapTables(table);
          }) || [];
          var data = XLSX.utils.json_to_sheet(dataToExport);
          var workbook = XLSX.utils.book_new();
          var filename = "tables-prod-report";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          _this5.isLoadingTables = false;
          XLSX.writeFile(workbook, "".concat(filename, "-").concat(_this5.domainTables, ".xlsx"));
        }
        if (_this5.full_metadata) {
          if (_this5.$gtm.enabled() && window.dataLayer) {
            window.dataLayer.push({
              event: GA_EVENTS.DOWNLOAD_MASSIVE_METADATA,
              all_tables: true,
              company_code: _this5.companyCode,
              full: true,
              hash_email: _this5.stringToHash(userInfo.email),
              module: 'data_platform'
            });
          }
          tasks.toast.success('Se ha creado la solicitud, el archivo llegará a su correo en breve');
        } else {
          if (_this5.$gtm.enabled() && window.dataLayer) {
            window.dataLayer.push({
              event: GA_EVENTS.DOWNLOAD_MASSIVE_METADATA,
              company_code: _this5.companyCode,
              all_tables: true,
              full: false,
              hash_email: _this5.stringToHash(userInfo.email),
              module: 'data_platform'
            });
          }
          tasks.toast.success('Metadata descargada');
        }
        _this5.isLoadingTables = false;
      });
      this.$refs["dialogDownloadProd"].onClose();
    },
    selectAllRows: function selectAllRows() {
      this.checkAll = !this.checkAll;
      if (this.checkAll) {
        this.$refs.selectableTable.selectAllRows();
      } else {
        this.$refs.selectableTable.clearSelected();
      }
    },
    changePagina: function changePagina(page) {
      console.log(page, this.pagination.tokens);
      if (page == 1) {
        this.nextToken = {};
        this.pagination.tokens = null;
        this.pagination.next_page_token = {};
      } else {
        this.nextToken = this.pagination.tokens[page];
      }
      this.reloadList();
    }
  }
};